

import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox } from "antd";
import backButton from '../../../../assets/images/back_button_arrow.svg';
import siteIcon from '../../../../assets/images/icons/site.svg';
import axios from "axios";
import { notifysuccess } from "../../../../utils/toast";
import { notifyfailure } from "../../../../utils/toast";
import { notifycatch } from "../../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../../config/config.json";
import loaderIcon from "../../../../assets/images/login-and-signup/loader.gif";
import { SearchOutlined } from '@ant-design/icons';
import demandIcon from '../../../../assets/images/icons/demand_icon.svg';
import FullLoader from "../../../../assets/images/full-page-loader.gif";
const { Option } = Select;

const ZoneViewEditFreewheel = ({ handlePageViewChange, handlePageViewEditBreadcrum, zoneViewId, zoneViewName, siteViewName, siteViewId }) => {


    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };


    // //////////////////////////////////////////////////////////////

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/freewheel/siteMinifiedList", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setSiteOptions_freewheel(response.data.data)

            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "ops/freewheel/tagList", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setTagsOpstions_freewheel(response.data.data)

            })
            .catch((error) => { });


        setSite_freewheel(siteViewName + "-" + siteViewId)

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "ops/freewheel/zoneDetails?zoneId=" + zoneViewId, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    setName_freewheel(response.data.data.name)
                    setCheckbox_vastDirect_freewheel(response.data.data.v_redirect)
                    setPositioning_freewheel(response.data.data.positioning)
                    setCheckbox_overlay_freewheel(response.data.data.overlay)
                    setIntegrationType_freewheel(response.data.data.integrationType)
                    setCheckbox_vpaid_freewheel(response.data.data.vpaid)
                    setTags_freewheel(response.data.data.tags)
                    setEfbPolicy_freewheel(response.data.data.epbPolicy)
                    setCheckbox_httpsOnly_freewheel(response.data.data.httpsOnly)

                    setFloorTypePrice_freewheel(response.data.data.fp_type)
                    setFloorPrice_freewheel(response.data.data.f_amount)
                    setPlayerHeight_freewheel(response.data.data.player_height)
                    setPlayerWidth_freewheel(response.data.data.player_width)
                    setAuctionType_freewheel(response.data.data.auction_type)

                    setCheckbox_frequency_freewheel(response.data.data.f_capping)
                    if (response.data.data.f_capping) {
                        setFrequencyLimit_freewheel(response.data.data.limit)
                        setFrequencyPerHour_freewheel(response.data.data.per.hour)
                        setFrequencyPerMinute_freewheel(response.data.data.per.minutes)
                        setFrequencyPerSecond_freewheel(response.data.data.per.seconds)
                    }

                    setCheckbox_skipAd_freewheel(response.data.data.skipEnabled)
                    if (response.data.data.skipEnabled) {
                        setSkipAdDurationType_freewheel(response.data.data.skipAdButton.type)
                        setSkipAdDuration_freewheel(response.data.data.skipAdButton.value)
                    }

                    setFormVisible(true)
                })
                .catch((error) => {
                    setFormVisible(true)
                    notifyfailure("Failed to fetch the zone details.")
                });



        }





    }, [])


    const [formVisible, setFormVisible] = useState(false);
    const [buttonProcessing, setButtonProcessing] = useState(false);



    // ------------------------------  FreeWheel Zone Code -----------------------------------------------------------
    // -------------------------------- States -------------------------------------------------------------------------

    const [site_freewheel, setSite_freewheel] = useState("");
    // const [site_https_freewheel, setSite_https_freewheel] = useState(false);

    const [siteIsRequiredError_freewheel, setSiteIsRequiredError_freewheel] = useState(false);
    const [siteOptions_freewheel, setSiteOptions_freewheel] = useState([]);



    const [name_freewheel, setName_freewheel] = useState("CTV_Xapads");
    const [nameIsRequiredError_freewheel, setNameIsRequiredError_freewheel] = useState(false);


    const [type_freewheel, setType_freewheel] = useState("Auto Populated (TV: Over-the-top)");


    // const [description_freewheel, setDescription_freewheel] = useState("");

    const [device_freewheel, setDevice_freewheel] = useState("TV");

    const [checkbox_vastDirect_freewheel, setCheckbox_vastDirect_freewheel] = useState(false);

    const [positioning_freewheel, setPositioning_freewheel] = useState(2);
    const [positioningOptions_freewheel] = useState([{ label: "Preroll", value: 2 }, { label: "Midroll", value: 3 }, { label: "Postroll", value: 4 }, { label: "Outstream", value: 5 }]);

    const [checkbox_overlay_freewheel, setCheckbox_overlay_freewheel] = useState(false);


    const [integrationType_freewheel, setIntegrationType_freewheel] = useState("open-rtb");
    const [integrationTypeOptions_freewheel] = useState([{ label: "OpenRTB", value: "open-rtb" }, { label: "Android SDK", value: "android-sdk" }, { label: "AppleTV SDK", value: "appletv-sdk" }, { label: "External", value: "vast" }, { label: "Prebid server adapter", value: "prebid-server" }]);

    const [checkbox_vpaid_freewheel, setCheckbox_vpaid_freewheel] = useState(false);

    const [tags_freewheel, setTags_freewheel] = useState([]);
    const [tagsOptions_freewheel, setTagsOpstions_freewheel] = useState([]);

    // const [passbackUrl_freewheel, setPassbackUrl_freewheel] = useState("");
    // const regexDomain = /.+[.].+/;
    // const [passbackUrlInvalidUrl_freewheel, setPassbackUrlInvalidUrl_freewheel] = useState(false);


    const [efbPolicy_freewheel, setEfbPolicy_freewheel] = useState("Allowed");
    const [checkbox_httpsOnly_freewheel, setCheckbox_httpsOnly_freewheel] = useState(false);
    // const [checkbox_liveEvent_freewheel, setCheckbox_liveEvent_freewheel] = useState(false);
    const [auctionType_freewheel, setAuctionType_freewheel] = useState("Default");


    // ---------------------------------------------------------------------------------------------------------------------------------------------------------

    const [floorTypePrice_freewheel, setFloorTypePrice_freewheel] = useState("Inherited (Gross)");
    const [floorTypePriceOptions_freewheel] = useState([{ label: "Inherited (Gross)", value: "Inherited (Gross)" }]);

    const [floorPrice_freewheel, setFloorPrice_freewheel] = useState("");
    const [floorPriceValidError_freewheel, setFloorPriceValidError_freewheel] = useState(false);
    const [floorPriceIsRequiredError_freewheel, setFloorPriceIsRequiredError_freewheel] = useState(false);

    // ---------------------------------------------------------------------------------------------------------------------------------------------------------

    const [checkbox_frequency_freewheel, setCheckbox_frequency_freewheel] = useState(false);

    const [frequencyLimit_freewheel, setFrequencyLimit_freewheel] = useState("");
    const [frequencyLimitError_freewheel, setFrequencyLimitError_freewheel] = useState(false);
    const [frequencyPerHour_freewheel, setFrequencyPerHour_freewheel] = useState("");
    const [frequencyPerMinute_freewheel, setFrequencyPerMinute_freewheel] = useState("");
    const [frequencyPerSecond_freewheel, setFrequencyPerSecond_freewheel] = useState("");
    const [frequencyPerError_freewheel, setFrequencyPerError_freewheel] = useState(false);


    // ---------------------------------------------------------------------------------------------------------------------------------------------------------

    const [playerWidth_freewheel, setPlayerWidth_freewheel] = useState("");
    const [playerWidthIsRequiredError_freewheel, setPlayerWidthIsRequiredError_freewheel] = useState(false);
    const [playerWidthValidError_freewheel, setPlayerWidthValidError_freewheel] = useState(false);

    const [playerHeight_freewheel, setPlayerHeight_freewheel] = useState("");
    const [playerHeightIsRequiredError_freewheel, setPlayerHeightIsRequiredError_freewheel] = useState(false);
    const [playerHeightValidError_freewheel, setPlayerHeightValidError_freewheel] = useState(false);


    const [checkbox_skipAd_freewheel, setCheckbox_skipAd_freewheel] = useState(false);

    const [skipAdDurationType_freewheel, setSkipAdDurationType_freewheel] = useState("Millisecond");
    const [skipAdDuration_freewheel, setSkipAdDuration_freewheel] = useState("");
    const [skipAdDurationIsRequiredError_freewheel, setSkipAdDurationIsRequiredError_freewheel] = useState(false);
    const [skipAdDurationValidError_freewheel, setSkipAdDurationValidError_freewheel] = useState(false);




    // --------------------------- Functions --------------------------------------------------------------

    function onChangeSite_freewheel(event) {
        setSiteIsRequiredError_freewheel(false)
        setSite_freewheel(event);

        // const selectedSite = siteOptions_freewheel?.find(
        //     (site) => site.value === event
        // );

        // setSite_https_freewheel(selectedSite?.httpsCheck)
    }



    function onChangeName_freewheel(event) {
        setNameIsRequiredError_freewheel(false);
        setName_freewheel(event.target.value);
    }

    function onBlurName_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError_freewheel(true);
        }
        setName_freewheel(event.target.value.trim());
    }


    // function onChangeDescription_freewheel(event) {
    //     setDescription_freewheel(event.target.value);
    // }


    function onChangeCheckboxVastDirect_freewheel(event) {
        setCheckbox_vastDirect_freewheel(event.target.checked);
    }

    const [searchValue, setSearchValue] = useState('');

    const handleSearch = (e) => {
        setSearchValue(e.target.value.toLowerCase());
    };

    const filteredTagsOptions_freewheel = tagsOptions_freewheel.filter(option =>
        option.label.toLowerCase().includes(searchValue)
    );

    function handleFilterApply(value) {
        let tempFilterApply = [...tags_freewheel]

        let newValue = [];
        if (tempFilterApply.includes(value)) {
            newValue = tempFilterApply.filter((item) => item !== value);
        } else {
            newValue = [...tempFilterApply, value];
        }
        tempFilterApply = newValue

        setTags_freewheel(tempFilterApply)

    }


    function onChangePositioning_freewheel(event) {
        setPositioning_freewheel(event);
    }

    function onChangeCheckboxOverlay_freewheel(event) {
        setCheckbox_overlay_freewheel(event.target.checked);
    }

    function onChangeIntegrationType_freewheel(event) {
        setIntegrationType_freewheel(event);
    }

    function onChangeCheckboxVpaid_freewheel(event) {
        setCheckbox_vpaid_freewheel(event.target.checked);
    }


    // function onChangePassbackUrl_freewheel(event) {
    //     setPassbackUrl_freewheel(event.target.value);

    //     setPassbackUrlInvalidUrl_freewheel(false);
    //     // if (event.target.value.trim().length > 0) {
    //     //     if (!regexDomain.test(event.target.value.trim())) {
    //     //         setPassbackUrlInvalidUrl_freewheel(true);
    //     //     }
    //     //     else {
    //     //         setPassbackUrlInvalidUrl_freewheel(false);
    //     //     }
    //     // }
    //     // else {
    //     //     setPassbackUrlInvalidUrl_freewheel(false);
    //     // }
    // }

    // function onBlurPassbackUrl_freewheel(event) {
    //     setPassbackUrl_freewheel(event.target.value.trim());
    //     if (event.target.value.trim().length > 0) {
    //         if (!regexDomain.test(event.target.value.trim())) {
    //             setPassbackUrlInvalidUrl_freewheel(true);
    //         }
    //         else {
    //             setPassbackUrlInvalidUrl_freewheel(false);
    //         }
    //     }

    // }

    function onChangeEfbPolicy_freewheel(event) {
        setEfbPolicy_freewheel(event.target.value);
    }


    function onChangeCheckboxHttpsOnly_freewheel(event) {
        setCheckbox_httpsOnly_freewheel(event.target.checked);
    }

    // function onChangeCheckboxLiveEvent_freewheel(event) {
    //     setCheckbox_liveEvent_freewheel(event.target.checked);
    // }


    // ---------------------------------------------------------------------------------------------------------------------------------------------------------

    function onChangeFloorPriceType_freewheel(event) {
        setFloorTypePrice_freewheel(event);
    }

    function onChangeFloorPrice_freewheel(event) {

        if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
            setFloorPrice_freewheel(event.target.value.trim());
            if ((Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 999) || Number(event.target.value.trim()) === 0) {
                setFloorPriceValidError_freewheel(false)
            }
            else {
                setFloorPriceValidError_freewheel(true)
            }
        }

        if (event.target.value.trim().length === 0) {
            setFloorPriceValidError_freewheel(false)
            setFloorPriceIsRequiredError_freewheel(true)
        }
        else {
            setFloorPriceIsRequiredError_freewheel(false)
        }
    }

    // ---------------------------------------------------------------------------------------------------------------------------------------------------------


    function onChangeCheckboxFrequency_freewheel(event) {
        setCheckbox_frequency_freewheel(event.target.checked);
        if (!event.target.checked) {
            setFrequencyLimitError_freewheel(false)
            setFrequencyPerError_freewheel(false)
            setFrequencyLimit_freewheel("")
            setFrequencyPerHour_freewheel("")
            setFrequencyPerMinute_freewheel("")
            setFrequencyPerSecond_freewheel("")
        }
    }

    function onChangeFrequencyLimit_freewheel(event) {
        setFrequencyLimitError_freewheel(false)

        if (/^\d*$/.test(event.target.value.trim())) {
            setFrequencyLimit_freewheel(event.target.value);

        }

    }

    function onChangeFrequencyPerHour_freewheel(event) {
        setFrequencyPerError_freewheel(false)
        if (/^\d*$/.test(event.target.value.trim())) {
            setFrequencyPerHour_freewheel(event.target.value);
        }

    }

    function onChangeFrequencyPerMinute_freewheel(event) {
        setFrequencyPerError_freewheel(false)
        if (/^\d*$/.test(event.target.value.trim())) {
            setFrequencyPerMinute_freewheel(event.target.value);
        }

    }

    function onChangeFrequencyPerSecond_freewheel(event) {
        setFrequencyPerError_freewheel(false)
        if (/^\d*$/.test(event.target.value.trim())) {
            setFrequencyPerSecond_freewheel(event.target.value);
        }

    }


    // ---------------------------------------------------------------------------------------------------------------------------------------------------------


    function onChangePlayerWidth_freewheel(event) {
        setPlayerWidthIsRequiredError_freewheel(false);
        if (/^\d*$/.test(event.target.value.trim())) {
            setPlayerWidth_freewheel(event.target.value);

            if (Number(event.target.value.trim()) < 9) {
                setPlayerWidthValidError_freewheel(true)
            }
            else {
                setPlayerWidthValidError_freewheel(false)
            }
        }
    }

    function onBlurPlayerWidth_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setPlayerWidthValidError_freewheel(false)
            setPlayerWidthIsRequiredError_freewheel(true);
        }
    }



    function onChangePlayerHeight_freewheel(event) {
        setPlayerHeightIsRequiredError_freewheel(false);
        if (/^\d*$/.test(event.target.value.trim())) {
            setPlayerHeight_freewheel(event.target.value);

            if (Number(event.target.value.trim()) < 9) {
                setPlayerHeightValidError_freewheel(true)
            }
            else {
                setPlayerHeightValidError_freewheel(false)
            }
        }
    }

    function onBlurPlayerHeight_freewheel(event) {
        if (event.target.value.trim().length === 0) {
            setPlayerHeightValidError_freewheel(false)
            setPlayerHeightIsRequiredError_freewheel(true);
        }
    }

    // ---------------------------------------------------------------------------------------------------------------------------------------------------------

    function onChangeCheckboxSkipAd_freewheel(event) {
        setCheckbox_skipAd_freewheel(event.target.checked);
        if (!event.target.checked) {
            setSkipAdDurationIsRequiredError_freewheel(false)
            setSkipAdDurationValidError_freewheel(false)
            setSkipAdDuration_freewheel("")
        }
    }

    function onChangeSkipAdDurationType_freewheel(event) {
        setSkipAdDurationType_freewheel(event.target.value);



        if (event.target.value === "Millisecond") {

            if (skipAdDuration_freewheel.trim().length > 0) {
                if (Number(skipAdDuration_freewheel.trim()) > 0) {
                    setSkipAdDurationValidError_freewheel(false)
                }
                else {
                    setSkipAdDurationValidError_freewheel(true)
                }
            }
        }
        else {

            if (skipAdDuration_freewheel.trim().length > 0) {
                if (Number(skipAdDuration_freewheel.trim()) > 0 && Number(skipAdDuration_freewheel.trim()) <= 99) {
                    setSkipAdDurationValidError_freewheel(false)
                }
                else {
                    setSkipAdDurationValidError_freewheel(true)
                }
            }

        }
    }

    function onChangeSkipAdDuration_freewheel(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setSkipAdDuration_freewheel(event.target.value.trim());

            if (skipAdDurationType_freewheel === "Millisecond") {
                if (Number(event.target.value.trim()) > 0) {
                    setSkipAdDurationValidError_freewheel(false)
                }
                else {
                    setSkipAdDurationValidError_freewheel(true)
                }

            }
            else {
                if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 99) {
                    setSkipAdDurationValidError_freewheel(false)
                }
                else {
                    setSkipAdDurationValidError_freewheel(true)
                }
            }


            if (event.target.value.trim()?.length === 0) {
                setSkipAdDurationValidError_freewheel(false)
                setSkipAdDurationIsRequiredError_freewheel(true)
            }
            else {
                setSkipAdDurationIsRequiredError_freewheel(false)
            }
        }
    }



    // function onChangeSkipAdDuration_freewheel(event) {
    //     setSkipAdDurationIsRequiredError_freewheel(false);
    //     if (/^\d*$/.test(event.target.value.trim())) {
    //         setSkipAdDuration_freewheel(event.target.value);
    //     }
    // }

    // function onBlurSkipAdDuration_freewheel(event) {
    //     if (event.target.value.trim().length === 0) {
    //         setSkipAdDurationIsRequiredError_freewheel(true);
    //     }
    // }


    const siteNameRef_zone_freewheel = useRef(null)
    const nameRef_zone_freewheel = useRef(null)

    const errorDetect = () => {
        if (site_freewheel === "") {
            scrollToItem(siteNameRef_zone_freewheel);
            return
        }

        if (name_freewheel.trim() === "") {
            scrollToItem(nameRef_zone_freewheel);
            return
        }

    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        if (
            site_freewheel !== "" &&
            name_freewheel !== "" &&
            floorPrice_freewheel !== "" &&
            playerHeight_freewheel !== "" &&
            playerWidth_freewheel !== "" &&
            (checkbox_skipAd_freewheel ? skipAdDuration_freewheel.trim().length > 0 : true) &&

            (checkbox_frequency_freewheel ? (Number(frequencyLimit_freewheel.trim()) > 0 && (Number(frequencyPerHour_freewheel.trim()) > 0 || Number(frequencyPerMinute_freewheel.trim()) > 0 || Number(frequencyPerSecond_freewheel.trim()) > 0)) : true)

        ) {
            if (
                siteIsRequiredError_freewheel === false &&
                nameIsRequiredError_freewheel === false &&
                // passbackUrlInvalidUrl_freewheel === false &&
                floorPriceValidError_freewheel === false &&
                floorPriceIsRequiredError_freewheel === false &&
                playerHeightIsRequiredError_freewheel === false &&
                playerWidthIsRequiredError_freewheel === false &&
                playerWidthValidError_freewheel === false &&
                playerHeightValidError_freewheel === false &&
                (checkbox_skipAd_freewheel ? skipAdDurationIsRequiredError_freewheel === false : true) &&
                (checkbox_skipAd_freewheel ? skipAdDurationValidError_freewheel === false : true)
            ) {


                if (integrationType_freewheel === "appletv-sdk") {
                    if (checkbox_vpaid_freewheel) {
                        notifyfailure("When integration type is Apple TV SDK , vpaid has to be set to false")
                        return
                    }
                }

                if (checkbox_vpaid_freewheel) {
                    if (!checkbox_vastDirect_freewheel) {
                        notifyfailure("When VPAID support is enabled, VAST redirect support must be checked")
                        return
                    }
                }


                let payload = {
                    site: site_freewheel,
                    site_type: {
                        "label": "Auto Populated (TV: Over-the-top)",
                        "value": "tv-ott"
                    },
                    name: name_freewheel.trim(),
                    // description: description_freewheel.trim(),
                    device: {
                        "label": "TV",
                        "value": "ott"
                    },
                    positioning: positioning_freewheel,
                    v_redirect: checkbox_vastDirect_freewheel,
                    overlay: positioning_freewheel === 4 || positioning_freewheel === 5 ? false : checkbox_overlay_freewheel,

                    integrationType: integrationType_freewheel,
                    vpaid: checkbox_vpaid_freewheel,
                    tags: tags_freewheel,
                    // pb_url: passbackUrl_freewheel,
                    epbPolicy: efbPolicy_freewheel,
                    // httpsOnly: site_https_freewheel ? false : checkbox_httpsOnly_freewheel,
                    httpsOnly: checkbox_httpsOnly_freewheel,
                    // liveEvent: checkbox_liveEvent_freewheel,
                    auction_type: auctionType_freewheel,
                    fp_type: floorTypePrice_freewheel,
                    f_amount: floorPrice_freewheel,
                    player_height: playerHeight_freewheel,
                    player_width: playerWidth_freewheel,
                    f_capping: checkbox_frequency_freewheel,
                    limit: checkbox_frequency_freewheel ? frequencyLimit_freewheel : "",
                    per: {
                        hour: checkbox_frequency_freewheel ? frequencyPerHour_freewheel : "",
                        minutes: checkbox_frequency_freewheel ? frequencyPerMinute_freewheel : "",
                        seconds: checkbox_frequency_freewheel ? frequencyPerSecond_freewheel : ""
                    },
                    skipEnabled: checkbox_skipAd_freewheel,
                    skipAdButton: {
                        type: checkbox_skipAd_freewheel ? skipAdDurationType_freewheel : "",
                        value: checkbox_skipAd_freewheel ? skipAdDuration_freewheel : ""
                    },

                }



                setButtonProcessing(true)

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                    // setButtonValue(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `ops/freewheel/editZone?zoneId=` + zoneViewId, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                handlePageViewChange("table", "yes")
                            }, 1000)

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }


            }
        } else {


            if (site_freewheel === "") {
                setSiteIsRequiredError_freewheel(true);
            }

            if (name_freewheel === "") {
                setNameIsRequiredError_freewheel(true);
            }

            if (floorPrice_freewheel === "") {
                setFloorPriceIsRequiredError_freewheel(true);
            }


            if (playerWidth_freewheel === "") {
                setPlayerWidthIsRequiredError_freewheel(true);
            }


            if (playerHeight_freewheel === "") {
                setPlayerHeightIsRequiredError_freewheel(true);
            }

            if (checkbox_skipAd_freewheel && skipAdDuration_freewheel.trim().length === 0) {
                setSkipAdDurationIsRequiredError_freewheel(true)
            }

            if (checkbox_frequency_freewheel && Number(frequencyLimit_freewheel.trim()) === 0) {
                setFrequencyLimitError_freewheel(true)
            }


            if (checkbox_frequency_freewheel && (Number(frequencyPerHour_freewheel.trim()) === 0 && Number(frequencyPerMinute_freewheel.trim()) === 0 && Number(frequencyPerSecond_freewheel.trim()) === 0)) {
                setFrequencyPerError_freewheel(true)
            }

        }

    }


    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">

                        <li >
                            <Link onClick={() => {
                                handlePageViewEditBreadcrum("table", "sites")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                FreeWheel
                            </Link>
                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                Zones
                            </Link>
                        </li>
                        <li className="primary">Edit Zone</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                            }}
                        />
                        <h1 className="heading">
                            {zoneViewName + " (" + zoneViewId + ")"}
                        </h1>
                    </div>
                </div>
                {formVisible &&
                    <div className="container_box--content pt_20">
                        <div className="container_box--width">

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Choose Site</label>
                                        <p className="sub_text">Select site for zone creation.</p>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0 hide_caret_after_select_value" ref={siteNameRef_zone_freewheel}>
                                                    <label className="form_label">Site Name </label>
                                                    <Select
                                                        showSearch
                                                        disabled
                                                        className={
                                                            siteIsRequiredError_freewheel
                                                                ? "form_select basic error"
                                                                : "form_select basic "
                                                        }
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        // onChange={onChangeSite_freewheel}
                                                        value={site_freewheel}
                                                        options={siteOptions_freewheel}
                                                    />
                                                    <span className="error_content">
                                                        {siteIsRequiredError_freewheel && (
                                                            <>This field is required </>
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>


                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>General details</label>
                                        <p className="sub_text">Please enter site details</p>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Type * </label>
                                                    <Input
                                                        className="form_control basic"
                                                        value={type_freewheel}
                                                        autocomplete="off"
                                                        disabled
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={nameRef_zone_freewheel}>
                                                    <label className="form_label">Name *</label>
                                                    <Input
                                                        className={
                                                            nameIsRequiredError_freewheel
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                        }
                                                        value={name_freewheel}
                                                        onBlur={onBlurName_freewheel}
                                                        onChange={onChangeName_freewheel}
                                                        autocomplete="off"
                                                    />
                                                    <span className="error_content">
                                                        {nameIsRequiredError_freewheel && (
                                                            <> This field is required</>
                                                        )}
                                                    </span>

                                                </div>
                                                {/* <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Description</label>
                                                <Input className='form_control basic form_control_h --80' autocomplete="off"
                                                    value={description_freewheel}
                                                    onChange={onChangeDescription_freewheel}
                                                />
                                                <span className="error_content"> </span>
                                            </div> */}
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Device *</label>
                                                    <Input className='form_control basic' disabled autocomplete="off" value={device_freewheel} />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_vastDirect_freewheel" name="checkbox_vastDirect_freewheel"
                                                            checked={checkbox_vastDirect_freewheel}
                                                            onChange={onChangeCheckboxVastDirect_freewheel}
                                                        >
                                                            <span className="form_label">
                                                                VAST Redirect
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Positioning *</label>
                                                    <Select
                                                        showSearch
                                                        className="form_select basic no_search "

                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        // onChange={}
                                                        value={positioning_freewheel}
                                                        options={positioningOptions_freewheel}
                                                        onChange={onChangePositioning_freewheel}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        {positioning_freewheel === 4 || positioning_freewheel === 5 ?
                                                            <Checkbox id="checkbox_overlay_freewheel" name="checkbox_overlay_freewheel"
                                                                checked={false}
                                                                disabled

                                                            >
                                                                <span className="form_label">
                                                                    Overlay
                                                                </span>
                                                            </Checkbox>
                                                            :
                                                            <Checkbox id="checkbox_overlay_freewheel" name="checkbox_overlay_freewheel"
                                                                checked={checkbox_overlay_freewheel}
                                                                onChange={onChangeCheckboxOverlay_freewheel}
                                                            >
                                                                <span className="form_label">
                                                                    Overlay
                                                                </span>
                                                            </Checkbox>
                                                        }

                                                    </div>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Integration Type * </label>
                                                    <Select
                                                        showSearch
                                                        className="form_select basic no_search "

                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        // onChange={}
                                                        value={integrationType_freewheel}
                                                        options={integrationTypeOptions_freewheel}
                                                        onChange={onChangeIntegrationType_freewheel}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_vpaid_freewheel" name="checkbox_vpaid_freewheel"
                                                            checked={checkbox_vpaid_freewheel}
                                                            onChange={onChangeCheckboxVpaid_freewheel}
                                                        >
                                                            <span className="form_label">
                                                                VPAID
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Tags </label>
                                                    {/* <Input className='form_control basic' autocomplete="off" /> */}
                                                    <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                                        <Select
                                                            id="adcodeSelect"
                                                            value={tags_freewheel}
                                                            popupClassName='diff_select_d2 --full'
                                                            showSearch={false}
                                                            placeholder={tags_freewheel.length === 0 ? '- Select -' : ""}
                                                            className="form_select basic no_search"
                                                            mode='multiple'
                                                            maxTagCount='responsive'
                                                            dropdownRender={menu => (
                                                                <>
                                                                    <div className="custom_inside_searchbar_d2">
                                                                        <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                    </div>
                                                                    {menu}
                                                                </>
                                                            )}
                                                        >
                                                            {filteredTagsOptions_freewheel.map(option => (
                                                                <Option key={option.value} value={option.value}>
                                                                    <div
                                                                        onClick={() => handleFilterApply(option.value)}
                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <Checkbox
                                                                            checked={tags_freewheel.includes(option.value)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {option.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                    <span className="error_content"> </span>
                                                </div>


                                                {/* 
                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Passback URL</label>
                                                <Input autocomplete="off"
                                                    className={
                                                        passbackUrlInvalidUrl_freewheel
                                                            ? "form_control basic form_control_h --80 error"
                                                            : "form_control basic form_control_h --80"
                                                    }
                                                    value={passbackUrl_freewheel}
                                                    onChange={onChangePassbackUrl_freewheel}
                                                    onBlur={onBlurPassbackUrl_freewheel}
                                                />
                                                <span className="error_content">
                                                    {passbackUrlInvalidUrl_freewheel && (
                                                        <> Invalid Url</>
                                                    )}
                                                </span>
                                            </div> */}
                                                <div className="form_content_block--group">
                                                    <label className="form_label">
                                                        EFB Policy *
                                                    </label>
                                                    <Radio.Group className="form_radio equal_space"
                                                        onChange={onChangeEfbPolicy_freewheel}
                                                        value={efbPolicy_freewheel}
                                                    >
                                                        <Radio className="radio_btn" value="Allowed" >
                                                            Allowed
                                                        </Radio>
                                                        <Radio className="radio_btn" value="Allowed but under condition" >
                                                            Allowed but under condition
                                                        </Radio>
                                                        <Radio className="radio_btn" value="Disallowed" >
                                                            Disallowed
                                                        </Radio>
                                                    </Radio.Group>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_httpsOnly_freewheel" name="checkbox_httpsOnly_freewheel"

                                                            // checked={site_https_freewheel ? false : checkbox_httpsOnly_freewheel}
                                                            // disabled={site_https_freewheel}
                                                            checked={checkbox_httpsOnly_freewheel}
                                                            onChange={onChangeCheckboxHttpsOnly_freewheel}>
                                                            <span className="form_label">
                                                                HTTPS only
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                {/* <div className="form_content_block--group">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="checkbox_liveevent_freewheel" name="checkbox_liveevent_freewheel"
                                                        checked={checkbox_liveEvent_freewheel}
                                                        onChange={onChangeCheckboxLiveEvent_freewheel}
                                                    >
                                                        <span className="form_label">
                                                            Live event
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div> */}
                                                <div className="form_content_block--group  hide_caret_after_select_value mb-0">
                                                    <label className="form_label">Auction Type * </label>
                                                    <Input autocomplete="off"
                                                        className="form_control basic"
                                                        value={auctionType_freewheel}
                                                        disabled
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Floor Prices</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Floor Price Type </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        value={floorTypePrice_freewheel}
                                                        onChange={onChangeFloorPriceType_freewheel}
                                                        options={floorTypePriceOptions_freewheel}
                                                        disabled
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group mb-0 prefixIconCss_d2">
                                                    <label className="form_label">Amount</label>
                                                    <Input
                                                        className={
                                                            (floorPriceValidError_freewheel || floorPriceIsRequiredError_freewheel)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                        }
                                                        autocomplete="off" prefix={'$'}
                                                        value={floorPrice_freewheel}
                                                        onChange={onChangeFloorPrice_freewheel}
                                                    />
                                                    <span className="error_content">
                                                        {floorPriceValidError_freewheel && (
                                                            <>Value must be less than or equal to 999</>
                                                        )}
                                                        {floorPriceIsRequiredError_freewheel && (
                                                            <>This field is required</>
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>


                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Frequency Capping</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkbox_frequency_freewheel" name="checkbox_frequency_freewheel"
                                                            checked={checkbox_frequency_freewheel}
                                                            onChange={onChangeCheckboxFrequency_freewheel}
                                                        >
                                                            <span className="form_label">
                                                                Enabled
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Limit to *</label>
                                                    <Input className={frequencyLimitError_freewheel ? 'form_control basic error' : 'form_control basic'} autocomplete="off" placeholder='0' suffix={
                                                        <em className='input_inside_text_d2'>impression(s)</em>
                                                    }
                                                        value={frequencyLimit_freewheel}
                                                        onChange={onChangeFrequencyLimit_freewheel}
                                                        disabled={!checkbox_frequency_freewheel}


                                                    />
                                                    <span className="error_content">{frequencyLimitError_freewheel && <>   Limit must be greater than 0</>} </span>
                                                </div>
                                                <Row gutter={8}>
                                                    <Col span={8}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label">Per *</label>
                                                            <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                                <em className='input_inside_text_d2'>hour(s)</em>
                                                            }

                                                                value={frequencyPerHour_freewheel}
                                                                onChange={onChangeFrequencyPerHour_freewheel}
                                                                disabled={!checkbox_frequency_freewheel}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </div>
                                                    </Col>
                                                    <Col span={8}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label invisible">Per *</label>
                                                            <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                                <em className='input_inside_text_d2'>minute(s)</em>
                                                            }


                                                                value={frequencyPerMinute_freewheel}
                                                                onChange={onChangeFrequencyPerMinute_freewheel}
                                                                disabled={!checkbox_frequency_freewheel}
                                                            />
                                                            <span className="error_content"></span>
                                                        </div>
                                                    </Col>
                                                    <Col span={8}>
                                                        <div className="form_content_block--group mb_0">
                                                            <label className="form_label invisible">Per *</label>
                                                            <Input className='form_control basic' autocomplete="off" placeholder='0' suffix={
                                                                <em className='input_inside_text_d2'>second(s)</em>
                                                            }


                                                                value={frequencyPerSecond_freewheel}
                                                                onChange={onChangeFrequencyPerSecond_freewheel}
                                                                disabled={!checkbox_frequency_freewheel}
                                                            />

                                                        </div>

                                                    </Col>
                                                    <span className="error_content">{frequencyPerError_freewheel && <>Per can't be set to 0. Please add a time value</>}  </span>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Player</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Width *</label>
                                                    <Input autocomplete="off"
                                                        className={
                                                            (playerWidthIsRequiredError_freewheel || playerWidthValidError_freewheel)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                        }
                                                        value={playerWidth_freewheel}
                                                        onChange={onChangePlayerWidth_freewheel}
                                                        onBlur={onBlurPlayerWidth_freewheel}

                                                    />
                                                </div>
                                                <span className="error_content">

                                                    {playerWidthIsRequiredError_freewheel && (
                                                        <> This field is required</>
                                                    )}
                                                    {playerWidthValidError_freewheel && (
                                                        <> Value must be greater than 9</>
                                                    )}
                                                </span>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Height *</label>
                                                    <Input
                                                        className={
                                                            (playerHeightIsRequiredError_freewheel || playerHeightValidError_freewheel)
                                                                ? "form_control basic error"
                                                                : "form_control basic"
                                                        }
                                                        autocomplete="off"
                                                        value={playerHeight_freewheel}
                                                        onChange={onChangePlayerHeight_freewheel}
                                                        onBlur={onBlurPlayerHeight_freewheel}
                                                    />
                                                    <span className="error_content">

                                                        {playerHeightIsRequiredError_freewheel && (
                                                            <> This field is required</>
                                                        )}
                                                        {playerHeightValidError_freewheel && (
                                                            <> Value must be greater than 9</>
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Skip AD Button</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col className='w_100'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className="form_content_block--group m-0">
                                                        <div className="primary_checkbox">
                                                            <Checkbox id="checkbox_skipAd_freewheel" name="checkbox_skipAd_freewheel"
                                                                checked={checkbox_skipAd_freewheel}
                                                                onChange={onChangeCheckboxSkipAd_freewheel}
                                                            >
                                                                <span className="form_label">
                                                                    Enabled
                                                                </span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <em className='input_inside_text_d2 p-0 text-nowrap'>This "skip ad button" only works with freewheel SDK.</em>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {checkbox_skipAd_freewheel &&
                                            <>
                                                <br />
                                                <div className="form_content_block--group">
                                                    <label className="form_label">
                                                        Duration Type *
                                                    </label>
                                                    <Radio.Group className="form_radio equal_space w-100"
                                                        onChange={onChangeSkipAdDurationType_freewheel}
                                                        value={skipAdDurationType_freewheel}
                                                    >
                                                        <Radio className="radio_btn" value="Millisecond" >
                                                            Millisecond
                                                        </Radio>
                                                        <Radio className="radio_btn" value="Percentage of the video" >
                                                            Percentage of the video
                                                        </Radio>
                                                    </Radio.Group>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value m-0">
                                                    <label className="form_label">Limit to *</label>
                                                    <Input

                                                        className={skipAdDurationIsRequiredError_freewheel || skipAdDurationValidError_freewheel ? 'form_control basic error' : 'form_control basic'} autocomplete="off" placeholder='0' suffix={
                                                            <em className='input_inside_text_d2'>This is the time before the Skip Ad is enabled</em>
                                                        }
                                                        value={skipAdDuration_freewheel}
                                                        onChange={onChangeSkipAdDuration_freewheel}
                                                    // onBlur={onBlurSkipAdDuration_freewheel}

                                                    />
                                                    <span className="error_content">
                                                        {skipAdDurationIsRequiredError_freewheel &&
                                                            <>This field is required</>

                                                        }
                                                        {skipAdDurationValidError_freewheel && skipAdDurationType_freewheel === "Millisecond" &&
                                                            <>Value must be greater than 0</>

                                                        }
                                                        {skipAdDurationValidError_freewheel && skipAdDurationType_freewheel === "Percentage of the video" &&
                                                            <>Value must be greater than 0 and less than or equal to 99</>

                                                        }
                                                    </span>
                                                </div>
                                                {/* <br />

                                            <div className="form_content_block--group">
                                                <label className="form_label">
                                                    Duration Type *
                                                </label>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeSkipAdDurationType_freewheel}
                                                    value={skipAdDurationType_freewheel}
                                                >
                                                    <Radio className="radio_btn" value="Millisecond" >
                                                        Millisecond
                                                    </Radio>
                                                    <Radio className="radio_btn" value="Percentage of the video" >
                                                        Percentage of the video
                                                    </Radio>

                                                </Radio.Group>
                                            </div>

                                            <div className="form_content_block--group hide_caret_after_select_value">
                                                <label className="form_label">Duration *</label>
                                                <Input className={skipAdDurationIsRequiredError_freewheel ? 'form_control basic error' : 'form_control basic'} autocomplete="off" placeholder='0' suffix={
                                                    <em className='input_inside_text_d2'>This is the time before the Skip Ad is enabled</em>
                                                }
                                                    value={skipAdDuration_freewheel}
                                                    onChange={onChangeSkipAdDuration_freewheel}
                                                    onBlur={onBlurSkipAdDuration_freewheel}
                                                />
                                                <span className="error_content">
                                                    {skipAdDurationIsRequiredError_freewheel &&
                                                        <>This field is required</>

                                                    }
                                                </span>
                                            </div> */}
                                            </>
                                        }
                                    </div>

                                </Col>
                            </Row>
                        </div>
                        {/* <div className="hr_custom mb_20"></div> */}
                        <div className="height_89_d2"></div>
                        <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                            {buttonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                        disabled
                                    >
                                        Discard
                                    </button>
                                    <button
                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                    >
                                        <span>Update Zone</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                </> :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                        onClick={() => {
                                            handlePageViewChange("table", "no")
                                        }}
                                    > Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content"
                                        onClick={handleSubmit}
                                    >Update Zone</button>
                                </>
                            }

                        </div>
                    </div>
                }

                {!formVisible &&
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                    </div>
                }
            </div>
        </>
    )
}

export default ZoneViewEditFreewheel
